import type { ConditionOption } from '../conditions.types';

/**
 * A matched option keeps its whole subtree; an unmatched one survives only if a
 * descendant matched, carrying just the matching option.
 */
export const filterOptionTree = (
  options: ConditionOption[],
  query: string
): ConditionOption[] => {
  if (!query) {
    return options;
  }

  const normalized = query.toLowerCase();

  return options.flatMap((option) => {
    if (option.label.toLowerCase().includes(normalized)) {
      return [option];
    }

    const subItems = filterOptionTree(option.subItems ?? [], query);

    return subItems.length > 0 ? [{ ...option, subItems }] : [];
  });
};
